import {
  Button,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  useMediaQuery
} from '@material-ui/core';
import { createStyles, makeStyles, withStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { Redirect, useHistory, useLocation, useParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import {
  getAssigneeRoles,
  getConstructInvoices,
  getConstructionDetails,
  getConstructionTypes,
  getConstructMerchandise,
  getConstructOutSources,
  getConstructSiteContacts,
  getPrefectureList,
  getScaleList,
  updateConstruction
} from '../apicalls/construction';
import { getEmployeeMasterList } from '../apicalls/employeeMaster';
import { updateEstimateStatus } from '../apicalls/estimates';
import {
  getConstructEstimate,
  updateInvoiceStatus,
  updatePaymentConfirmDate,
  updateInvoiceReceiptIssueStatus
} from '../apicalls/invoices';
import {
  updateStatus,
  updateMerchandiseStatus
} from '../apicalls/merchandiseOrder';
import { partialUpdateOutsourceStatus } from '../apicalls/outsource';
import '../App.css';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import { DatePickerInput } from '../components/atoms';
import LoadingComponent from '../components/LoadingComponent';
import SortButton from '../components/SortButton';
import {
  btnColor,
  invalidPhoneNumberRegex,
  isLoggedIn,
  mainBlueColor,
  userRole,
  userMenuId,
  tenantTaxRuleState,
  userSiteManagePlanId
} from '../GlobalState';
import { parsePrice } from '../utils';
import { calcTax, formatDatetime } from '../utils/common';
import './List.css';
import { ListButton } from '../components/parts/cloudStorage/style/style';
import {
  CONTRACT_FORMAT_DIR_PATH,
  CONTRACT_FORMAT_ICON_DIR_PATH,
  formatFiles
} from '../const/ContractFormat';
import GetAppIcon from '@material-ui/icons/GetApp';
import { log } from '../utils';
import {
  SITE_MANGE_PLAN_ACCESS_ALLOW,
  RECEIPT_ISSUE_STATUS,
  EXT_INFO_SCREEN_TYPE
} from '../const/Const';
import { ExtInfoBoxes } from '../components/extInfoBox/ExtInfoBoxes';
import { TInfoBox } from '../types/ExtInfoBox';
import { getExtInfoBoxes } from '../apicalls/extInfoBox';
import { useSnackbar } from 'notistack';
import { checkResData } from '../utils/common';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    },
    '&:hover': {
      backgroundColor: '#CFCFCF'
    }
  }
}))(TableRow);

export const EditConstructionDocument: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const [isPhoneNumber] = useRecoilState(invalidPhoneNumberRegex);
  const [userPermission] = useRecoilState(userRole);
  const [userMenu] = useRecoilState(userMenuId);
  const [taxRule] = useRecoilState(tenantTaxRuleState);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      subContainer: {
        marginLeft: 15,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row'
      },
      topBoxText: {
        fontSize: 14,
        color: '#000000'
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      },
      table1: {},
      inputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 60,
        alignItems: 'center',
        width: '100%'
      },
      inputnew: {
        minHeight: 100,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      inputContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        width: '100%'
      },
      textMainContainer2: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 125,
        alignItems: 'center'
      },
      textMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 60,
        alignItems: 'center'
      },
      textContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input: {
        minHeight: 40,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      inputMainContainer1: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 80,
        alignItems: 'center',
        width: '100%'
      },
      textMainContainer1: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 80,
        alignItems: 'center'
      },
      textContainer1: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input1: {
        minHeight: 60,
        width: '100%'
      },
      inputContainerSelectBox: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%'
      },
      textContainerPrice: {
        marginLeft: 10,
        marginRight: 13,
        textAlign: 'right',
        width: '100%'
      },
      main: {
        minWidth: 700
      },
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        fontWeight: 'bold',
        fontSize: 16
      },
      selectBoxStyle: {
        WebkitAppearance: 'menulist-button',
        backgroundColor: 'white',
        borderColor: '#c1c1c1',
        minHeight: 48,
        width: '100%'
      },
      inputBottom: {
        height: 30,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      inputPostalCode: {
        height: 40,
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      tooltip: {
        fontSize: 14
      },
      topContainer: {
        display: 'flex',
        paddingBottom: 15,
        justifyContent: 'space-between'
      },
      topList: {
        display: 'flex',
        marginTop: 25,
        marginBottom: 25,
        width: '100%',
        justifyContent: 'flex-start'
      },
      topColumn: {
        fontSize: 16,
        color: '#000000'
      }
    })
  );

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const classes = useStyles();
  const history: any = useHistory();
  const location: any = useLocation();
  const matches2 = useMediaQuery('(min-width:900px)');
  const [userSiteManagePlan, setUserSiteMangePlan] =
    useRecoilState<any>(userSiteManagePlanId);
  const [userPlanId, setUserPlanId] = useRecoilState<any>(userMenuId);
  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [typesData, setTypesData] = useState([]);
  const [scaleData, setScaleData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [prefectureData, setPrefectureData] = useState([]);
  const [assigneeRoleData, setAssigneeRoleData] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [topConstructionName, setTopConstructionName] = useState(''); // 工事詳細を開いた時のみ変更
  const [topClientName, setTopClientName] = useState(''); // 工事詳細を開いた時のみ変更
  const [isSaved, setIsSaved] = useState<boolean>(true); // 変更内容を保存していない場合False

  const [code, setCode] = useState('');
  const [constructType, setConstructType] = useState<number>(0);
  const [renewStatus, setRenewStatus] = useState<number>(0);
  const [buildingScale, setBuildingScale] = useState<number>(0);
  const [name, setName] = useState('');
  const [sitePrefecture, setSitePrefecture] = useState<number>(0);
  const [siteAddress1, setSiteAddress1] = useState('');
  const [siteAddress2, setSiteAddress2] = useState('');
  const [siteAddress3, setSiteAddress3] = useState('');
  const [remarks, setRemarks] = useState<string>('');
  const [contractorPrefecture, setContractorPrefecture] = useState<number>(0);
  const [contractorAddress1, setContractorAddress1] = useState('');
  const [contractorAddress2, setContractorAddress2] = useState('');
  const [contractorAddress3, setContractorAddress3] = useState('');
  const [contractorName, setContractorName] = useState('');
  const [contractorTel, setContractorTel] = useState('');
  const [progress, setProgress] = useState<number>(0);
  const [plannedCost, setPlannedCost] = useState<number>(0);
  const [plannedDays, setPlannedDays] = useState<number>(0);
  const [plannedGrossProfit, setPlannedGrossProfit] = useState<number>(0);
  const [plannedGrossProfitRate, setPlannedGrossProfitRate] =
    useState<number>(0);
  const [smallExpenses, setSmallExpenses] = useState<number>(0);

  const [contractDate, setContractDate] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [billingDate, setBillingDate] = useState('');
  const [paymentDate, setPaymentDate] = useState('');
  const [failureDate, setFailureDate] = useState('');
  const [inspectionDate, setInspectionDate] = useState('');

  const [clientName, setClientName] = useState('');
  const [clientTel, setClientTel] = useState('');
  const [clientPrefecture, setClientPrefecture] = useState('');
  const [clientAddress1, setClientAddress1] = useState('');
  const [clientAddress2, setClientAddress2] = useState('');
  const [clientAddress3, setClientAddress3] = useState('');

  const [contractTaxRate, setContractTaxRate] = useState<number>(10);
  const [selectedTable, setSelectedTable] = useState('estimates');

  const [expectedContractDate, setExpectedContractDate] = useState('');
  const [expectedStartDate, setExpectedStartDate] = useState('');
  const [expectedEndDate, setExpectedEndDate] = useState('');
  const [expectedPaymentDate, setExpectedPaymentDate] = useState('');

  const [loading, setLoading] = useState(true);

  const [itemIds, setItemIds] = useState<any>([]);
  const [itemIds2, setItemIds2] = useState<any>([]);

  const [rowCount, setRowCount] = useState<any>([1]);
  const [rowCount2, setRowCount2] = useState<any>([1]);
  const [assigneeUser, setAssigneeUser] = useState<any>([]);
  const [assigneeRole, setAssigneeRole] = useState<any>([]);
  const [contributionList, setContributionList] = useState<any>([]);
  const [individualSalesList, setIndividualSalesList] = useState<any>([]);
  const [assigneeOutsidePartner, setAssigneeOutsidePartner] = useState<any>([]);
  const [assigneeOutsidePartnerRole, setAssigneeOutsidePartnerRole] =
    useState<any>([]);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  const [selectedContractDate, setSelectedContractDate] =
    useState<Date | null>(null);
  const [selectedStartDate, setSelectedStartDate] = useState<Date | null>(null);
  const [selectedEndDate, setSelectedEndDate] = useState<Date | null>(null);
  const [selectedBillingDate, setSelectedBillingDate] =
    useState<Date | null>(null);
  const [selectedPaymentDate, setSelectedPaymentDate] =
    useState<Date | null>(null);
  const [selectedFailureDate, setSelectedFailureDate] =
    useState<Date | null>(null);
  const [selectedInspectionDate, setSelectedInspectionDate] =
    useState<Date | null>(null);
  const [selectedExpectedContractDate, setSelectedExpectedContractDate] =
    useState<Date | null>(null);
  const [selectedExpectedStartDate, setSelectedExpectedStartDate] =
    useState<Date | null>(null);
  const [selectedExpectedEndDate, setSelectedExpectedEndDate] =
    useState<Date | null>(null);
  const [selectedExpectedPaymentDate, setSelectedExpectedPaymentDate] =
    useState<Date | null>(null);

  const [constructEstimatesData, setConstructEstimatesData] = useState([]);
  const [constructInvoicesData, setConstructInvoicesData] = useState([]);
  const [constructMerchandiseData, setConstructMerchandiseData] = useState([]);
  const [constructOutSourcesData, setConstructOutSourcesData] = useState([]);
  const [constructSiteContactsData, setConstructSiteContactsData] = useState(
    []
  );
  const [itemStatus, setItemStatus] = useState<any>([]);

  const [orderAmount, setOrderAmount] = useState<number>(0);
  const [depositAmount, setDepositAmount] = useState<number>(0);
  const [receivableAmount, setReceivableAmount] = useState<number>(0);
  const [materialCost, setMaterialCost] = useState<number>(0);
  const [outsourcingCost, setOutsourcingCost] = useState<number>(0);
  const [executionCost, setExecutionCost] = useState<number>(0);
  const [costDifference, setCostDifference] = useState<number>(0);
  const [grossProfitDifference, setGrossProfitDifference] = useState<number>(0);
  const [grossProfitRateDifference, setGrossProfitRateDifference] =
    useState<number>(0);
  const [execustionGrossProfit, setExecustionGrossProfit] = useState<number>(0);
  const [execustionGrossProfitRate, setExecustionGrossProfitRate] =
    useState<number>(0);
  const [dailyGrossProfit, setDailyGrossProfit] = useState<number>(0);
  const [constructDays, setConstructDays] = useState<number>(0);

  const [companyName, setCompanyName] = useState('');
  const [companyCode, setCompanyCode] = useState('');
  const [companyPostalCode1, setCompanyPostalCode1] = useState('');
  const [companyPostalCode2, setCompanyPostalCode2] = useState('');
  const [companyAddress, setCompanyAddress] = useState('');
  const [companyPhoneNumber, setCompanyPhoneNumber] = useState('');
  const [companyFaxNumber, setCompanyFaxNumber] = useState('');
  const [latitude, setLatitude] = useState(35.69575);
  const [longitude, setLongitude] = useState(139.77521);
  const [isMarkerChecked, setIsMarkerChecked] = useState(false);
  const [possibleTime, setPossibleTime] = useState('');
  const [parkSpace, setParkSpace] = useState('');
  const [smokingRule, setSmokingRule] = useState('');
  const [importantOthers, setImportantOthers] = useState('');

  const [janitorName, setJanitorName] = useState('');
  const [janitorPhoneNumber, setJanitorPhoneNumber] = useState('');
  const [janitorFaxNumber, setJanitorFaxNumber] = useState('');
  const [janitorWorkHours, setJanitorWorkHours] = useState<string>('');
  const [janitorOthers, setJanitorOthers] = useState('');

  const [deleteItemList, setDeleteItemList] = useState<any>([]);
  const [deleteItemList2, setDeleteItemList2] = useState<any>([]);

  const [smallExpenseItems, setSmallExpenseItems] = useState<any>([]);

  // 選択タブ番号(1:工事情報、2:書類情報、3:現場情報、4:追加情報)
  const [selectTab, setSelectTab] = useState<number>(2);

  // 見積タブ日付ソート用
  const [sortEstimateParams, setEstimateSortParams] = useState<any>({
    sort_field: null,
    sort_direction: null
  });
  const [sortEstimateButtonName, setEstimateSortButtonName] = useState('');
  const changeEstimateSortParams = (params: any) => {
    setEstimateSortParams(params);
  };

  const [defaultValues, setDefaultValues] = useState<TInfoBox[]>();

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    getExtInfoBoxes(history.location.state.constructId, 2).then((data: any) => {
      if (data.data === 'Not logged in!') {
        setOpen(true);
        setErrorMessage(data.data);
      } else {
        if (typeof data.data === 'string') {
          setOpen(true);
          setErrorMessage(data.data);
        } else {
          setDefaultValues(data.data);
        }
      }
    });
  };

  // 請求書タブ日付ソート用
  const [sortInvoiceParams, setSortInvoiceParams] = useState<any>({
    sort_field: 'payment_date',
    sort_direction: null
  });
  const [sortInvoiceButtonName, setSortInvoiceButtonName] = useState('');
  const changeInvoiceSortParams = (params: any) => {
    setSortInvoiceParams(params);
  };

  // 商品発注書タブ日付ソート用
  const [sortMerchandiseParams, setSortMerchandiseParams] = useState<any>({
    sort_field: null,
    sort_direction: null
  });
  const [sortMerchandiseButtonName, setSortMerchandiseButtonName] =
    useState('');
  const changeMerchandiseSortParams = (params: any) => {
    setSortMerchandiseParams(params);
  };

  // 外注発注書タブ日付ソート用
  const [sortOutsourceParams, setSortOutsourceParams] = useState<any>({
    sort_field: null,
    sort_direction: null
  });
  const [sortOutsourceButtonName, setSortOutsourceButtonName] = useState('');
  const changeOutsourceSortParams = (params: any) => {
    setSortOutsourceParams(params);
  };

  // 現場連絡表タブ日付ソート用
  const [sortSiteContactParams, setSortSiteContactParams] = useState<any>({
    sort_field: null,
    sort_direction: null
  });
  const [sortSiteContactButtonName, setSortSiteContactButtonName] =
    useState('');
  const changeSiteContactSortParams = (params: any) => {
    setSortSiteContactParams(params);
  };

  const { enqueueSnackbar } = useSnackbar();

  const getListOfConstructionTypes = useCallback(() => {
    getConstructionTypes().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setTypesData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfScales = useCallback(() => {
    getScaleList().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setScaleData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfAssigneeRoles = useCallback(() => {
    getAssigneeRoles().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setAssigneeRoleData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfPrefectures = useCallback(() => {
    getPrefectureList().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setPrefectureData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfUsers = useCallback(() => {
    getEmployeeMasterList('', 1).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setUserData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfConstructEstimates = useCallback(() => {
    getConstructEstimate(
      history.location.state.constructId,
      sortEstimateParams.sort_field,
      sortEstimateParams.sort_direction
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setConstructEstimatesData(data.data);
          }
        }
      }
    });
  }, [
    changeLoggedInData,
    history.location.state.constructId,
    sortEstimateParams.sort_direction,
    sortEstimateParams.sort_field
  ]);

  const getListOfConstructInvoices = useCallback(() => {
    getConstructInvoices(
      history.location.state.constructId,
      sortInvoiceParams.sort_field,
      sortInvoiceParams.sort_direction
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setConstructInvoicesData(data.data);
          }
        }
      }
    });
  }, [
    changeLoggedInData,
    history.location.state.constructId,
    sortInvoiceParams.sort_direction,
    sortInvoiceParams.sort_field
  ]);

  const getListOfConstructMerchandise = useCallback(() => {
    getConstructMerchandise(
      history.location.state.constructId,
      sortMerchandiseParams.sort_field,
      sortMerchandiseParams.sort_direction
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setConstructMerchandiseData(data.data);
            data.data.forEach((i: any, j: number) => {
              setItemStatus((itemStatus: any) => [...itemStatus, i.status]);
            });
          }
        }
      }
    });
  }, [
    changeLoggedInData,
    history.location.state.constructId,
    sortMerchandiseParams.sort_direction,
    sortMerchandiseParams.sort_field
  ]);

  const getListOfConstructOutSources = useCallback(() => {
    getConstructOutSources(
      history.location.state.constructId,
      sortOutsourceParams.sort_field,
      sortOutsourceParams.sort_direction
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setConstructOutSourcesData(data.data);
          }
        }
      }
    });
  }, [
    changeLoggedInData,
    history.location.state.constructId,
    sortOutsourceParams.sort_direction,
    sortOutsourceParams.sort_field
  ]);

  const getListOfConstructSiteContacts = useCallback(() => {
    getConstructSiteContacts(
      history.location.state.constructId,
      sortSiteContactParams.sort_field,
      sortSiteContactParams.sort_direction
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setConstructSiteContactsData(data.data);
          }
        }
      }
    });
  }, [
    changeLoggedInData,
    history.location.state.constructId,
    sortSiteContactParams.sort_direction,
    sortSiteContactParams.sort_field
  ]);

  const getTheDetailsOfConstrctions = () => {
    getConstructionDetails(history.location.state.constructId).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setCode(data.data.code);
            setConstructType(data.data.construct_type);
            setRenewStatus(data.data.renew_status);
            if (data.data.building_scale) {
              setBuildingScale(data.data.building_scale);
            }
            setTopConstructionName(data.data.name);
            setName(data.data.name);
            if (data.data.site_prefecture) {
              setSitePrefecture(data.data.site_prefecture);
            }
            setSiteAddress1(data.data.site_address1);
            setSiteAddress2(data.data.site_address2);
            setSiteAddress3(data.data.site_address3);
            setRemarks(data.data.remarks);

            setContractorPrefecture(data.data.contractor_prefecture);
            setContractorAddress1(data.data.contractor_address1);
            setContractorAddress2(data.data.contractor_address2);
            setContractorAddress3(data.data.contractor_address3);

            setContractorName(data.data.contractor_name);
            setContractorTel(data.data.contractor_tel);
            setProgress(data.data.progress_status);
            if (data.data.planned_cost) {
              setPlannedCost(data.data.planned_cost);
            }
            if (data.data.planned_days) {
              setPlannedDays(data.data.planned_days);
            }
            if (data.data.planned_gross_profit) {
              setPlannedGrossProfit(data.data.planned_gross_profit);
            }
            if (data.data.planned_gross_profit_rate) {
              setPlannedGrossProfitRate(data.data.planned_gross_profit_rate);
            }
            setContractDate(data.data.contract_date);
            if (data.data.contract_date !== '') {
              setSelectedContractDate(new Date(data.data.contract_date));
            }
            setStartDate(data.data.start_date);
            if (data.data.start_date !== '') {
              setSelectedStartDate(new Date(data.data.start_date));
            }
            setEndDate(data.data.end_date);
            if (data.data.end_date !== '') {
              setSelectedEndDate(new Date(data.data.end_date));
            }
            setBillingDate(data.data.billing_date);
            if (data.data.billing_date !== '') {
              setSelectedBillingDate(new Date(data.data.billing_date));
            }
            setPaymentDate(data.data.payment_date);
            if (data.data.payment_date !== '') {
              setSelectedPaymentDate(new Date(data.data.payment_date));
            }
            setFailureDate(data.data.failure_date);
            if (data.data.failure_date !== '') {
              setSelectedFailureDate(new Date(data.data.failure_date));
            }
            setInspectionDate(data.data.inspection_date);
            if (data.data.inspection_date !== '') {
              setSelectedInspectionDate(new Date(data.data.inspection_date));
            }
            setContractTaxRate(data.data.contract_tax_rate);
            setExpectedContractDate(data.data.expected_contract_date);
            if (data.data.expected_contract_date !== '') {
              setSelectedExpectedContractDate(
                new Date(data.data.expected_contract_date)
              );
            }
            setExpectedStartDate(data.data.expected_start_date);
            if (data.data.expected_start_date !== '') {
              setSelectedExpectedStartDate(
                new Date(data.data.expected_start_date)
              );
            }
            setExpectedEndDate(data.data.expected_end_date);
            if (data.data.expected_end_date !== '') {
              setSelectedExpectedEndDate(new Date(data.data.expected_end_date));
            }
            setExpectedPaymentDate(data.data.expected_payment_date);
            if (data.data.expected_payment_date) {
              setSelectedExpectedPaymentDate(
                new Date(data.data.expected_payment_date)
              );
            }
            if (data.data.small_expenses && data.data.small_expenses !== '') {
              setSmallExpenses(data.data.small_expenses);
            }
            if (data.data.small_expense_items.length > 0) {
              let items = [...data.data.small_expense_items];
              // 小口経費明細ができる前のデータをGetすると、nameにnullが入って、保存時にエラーになる為。
              if (items[0].name === null) {
                items[0].name = '';
              }
              setSmallExpenseItems(items);
              let priceArray: number[] = [];
              items.map(item => priceArray.push(item.price));
              let totalPrice: number = priceArray.reduce((a, b) => a + b);
              setSmallExpenses(totalPrice);
            }
            setTopClientName(data.data.client_name);
            setClientName(data.data.client_name);
            setClientName(data.data.client_name);
            setClientTel(data.data.client_tel);
            setClientPrefecture(data.data.client_prefecture);
            setClientAddress1(data.data.client_address1);
            setClientAddress2(data.data.client_address2);
            setClientAddress3(data.data.client_address3);

            setOrderAmount(data.data.order_amount);
            setDepositAmount(data.data.deposit_amount);
            setReceivableAmount(data.data.receivable_amount);
            setMaterialCost(data.data.material_cost);
            setOutsourcingCost(data.data.outsourcing_cost);
            setExecutionCost(data.data.execution_cost);
            setCostDifference(data.data.cost_difference);
            setGrossProfitDifference(data.data.gross_profit_difference);
            setGrossProfitRateDifference(
              data.data.gross_profit_rate_difference
            );
            setExecustionGrossProfit(data.data.execustion_gross_profit);
            setExecustionGrossProfitRate(
              data.data.execustion_gross_profit_rate
            );
            setDailyGrossProfit(data.data.daily_gross_profit);
            setCompanyName(data.data.company_name);
            setCompanyCode(data.data.company_code);
            setCompanyPostalCode1(data.data.company_postal_code.slice(0, 3));
            setCompanyPostalCode2(data.data.company_postal_code.slice(-4));
            setCompanyAddress(data.data.company_address);
            setCompanyPhoneNumber(data.data.company_phone_number);
            setCompanyFaxNumber(data.data.company_fax_number);
            setLatitude(data.data.latitude);
            setLongitude(data.data.longitude);
            setIsMarkerChecked(data.data.is_marker_checked);
            setPossibleTime(data.data.possible_time);
            setParkSpace(data.data.park_space);
            setSmokingRule(data.data.smoking_rule);
            setImportantOthers(data.data.important_others);
            setJanitorName(data.data.janitor_name);
            setJanitorPhoneNumber(data.data.janitor_phone_number);
            setJanitorFaxNumber(data.data.janitor_fax_number);
            setJanitorWorkHours(data.data.janitor_work_hours);
            setJanitorOthers(data.data.janitor_others);
            setConstructDays(data.data.construct_days);
            let iIds: any = [];
            let iIds2: any = [];
            let iRowCount: any = rowCount;
            let iRowCount2: any = rowCount2;
            let iAssigneeUser: any = [];
            let iAssigneeRole: any = [];
            let iContributionList: any = [];
            let iIndividualSalesList: any = [];
            let iAssigneeOutsidePartner: any = [];
            let iAssigneeOutsidePartnerRole: any = [];
            data.data.assignee_list.map((k: any, index: number) => {
              if (k.assignee_role !== 5) {
                // 担当者
                if (index === 0) {
                  setRowCount(iRowCount);
                } else {
                  iRowCount.push(1);
                  setRowCount(iRowCount);
                }
                iIds.push(k.id);
                iAssigneeUser.push(k.assignee_user);
                setAssigneeUser(iAssigneeUser);
                iAssigneeRole.push(k.assignee_role);
                setAssigneeRole(iAssigneeRole);

                iContributionList.push(parseFloat(k.contribution));
                setContributionList(iContributionList);

                iIndividualSalesList.push(
                  (parseFloat(k.contribution) * data.data.order_amount) / 100
                );
                setIndividualSalesList(iIndividualSalesList);
              } else {
                // 社外パートナー
                iRowCount2.push(1);
                setRowCount2(iRowCount2);
                iIds2.push(k.id);
                iAssigneeOutsidePartner.push(k.assignee_user);
                setAssigneeOutsidePartner(iAssigneeOutsidePartner);
                iAssigneeOutsidePartnerRole.push(k.assignee_role);
                setAssigneeOutsidePartnerRole(iAssigneeOutsidePartnerRole);
              }
              return <></>;
            });

            setItemIds(iIds);
            setItemIds2(iIds2);
            setLoading(false);
          }
        }
      }
    });
  };

  useEffect(() => {
    getListOfConstructionTypes();
    getListOfScales();
    getListOfPrefectures();
    getListOfUsers();
    getListOfAssigneeRoles();
    getTheDetailsOfConstrctions();
    getListOfConstructEstimates();
    getListOfConstructInvoices();
    getListOfConstructMerchandise();
    getListOfConstructOutSources();
    getListOfConstructSiteContacts();
    // 無限ループになるためgetTheDetailsOfConstructionsを除外
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    getListOfConstructionTypes,
    getListOfScales,
    getListOfPrefectures,
    getListOfUsers,
    getListOfAssigneeRoles,
    getListOfConstructInvoices,
    getListOfConstructMerchandise,
    getListOfConstructOutSources,
    getListOfConstructSiteContacts,
    getListOfConstructEstimates
  ]);

  useEffect(() => {
    setReceivableAmount(
      orderAmount +
        calcTax(orderAmount, contractTaxRate / 100, taxRule) -
        depositAmount
    );
  }, [orderAmount, contractTaxRate, depositAmount, receivableAmount]);

  const updateConstructionDetails = () => {
    let small_expense_item: any = [];
    for (let n = 0; n < smallExpenseItems.length; n++) {
      if (
        smallExpenseItems[n].price !== '' &&
        smallExpenseItems[n].name.length <= 30
      ) {
        small_expense_item[n] = {
          name: smallExpenseItems[n].name,
          price: smallExpenseItems[n].price,
          id: smallExpenseItems[n].id
        };
      } else if (smallExpenseItems[n].name.length > 30) {
        setErrorMessage('経費項目は30文字以内で入力してください。');
        setOpen(true);
        return;
      } else if (smallExpenseItems[n].price === '') {
        setErrorMessage('金額を入力してください。');
        setOpen(true);
        return;
      }
    }
    setSmallExpenseItems(small_expense_item);

    let contriSum = 0;
    for (let i = 0; i < contributionList.length; i++) {
      contriSum += contributionList[i];
    }
    if (code.trim() === '') {
      setErrorMessage('工事番号を入力してください。');
      setOpen(true);
    } else if (code.length > 10) {
      setErrorMessage('工事番号は10文字以内で記入してください。');
      setOpen(true);
    } else if (constructType === 0 || !constructType) {
      setErrorMessage('案件種別を選択してください。');
      setOpen(true);
    } else if (renewStatus === 0) {
      setErrorMessage('「新規」または「リピート」を選択してください。');
      setOpen(true);
    } else if (name.trim() === '') {
      setErrorMessage('工事件名を入力してください。');
      setOpen(true);
    } else if (name.length > 60) {
      setErrorMessage('工事件名は60文字以内で記入してください。');
      setOpen(true);
    } else if (userMenu != 'Storage' && progress === 0) {
      setErrorMessage('進行状況を入力してください。');
      setOpen(true);
    } else if (
      contractorTel.trim() !== '' &&
      (isPhoneNumber.test(contractorTel.trim()) ||
        contractorTel.trim().length > 20)
    ) {
      setErrorMessage('無効な連絡先TEL');
      setOpen(true);
    } else if (userMenu != 'Storage' && assigneeUser.length === 0) {
      setErrorMessage('担当者名を入力してください。');
      setOpen(true);
    } else if (userMenu != 'Storage' && assigneeRole.length === 0) {
      setErrorMessage('担当役割を入力してください。');
      setOpen(true);
    } else if (userMenu != 'Storage' && contributionList.length === 0) {
      setErrorMessage('貢献度を入力してください。');
      setOpen(true);
    } else if (userMenu != 'Storage' && contriSum !== 100) {
      setErrorMessage('貢献度の合計は100％でなければなりません');
      setOpen(true);
    } else if (companyName.length > 30) {
      setErrorMessage('会社名は30文字以内で入力してください。');
      setOpen(true);
    } else if (
      companyPhoneNumber.trim() !== '' &&
      (isPhoneNumber.test(companyPhoneNumber.trim()) ||
        companyPhoneNumber.trim().length > 20)
    ) {
      setErrorMessage('無効な電話番号になっています。');
      setOpen(true);
    } else if (
      companyPostalCode1 !== '' &&
      companyPostalCode2 !== '' &&
      (companyPostalCode1.length !== 3 || companyPostalCode2.length !== 4)
    ) {
      setErrorMessage('郵便番号の形式が間違っています。');
      setOpen(true);
    } else if (companyAddress.length > 60) {
      setErrorMessage('所在地は60文字以内で入力してください。');
      setOpen(true);
    } else {
      let l1 = assigneeUser.length;
      let l2 = assigneeRole.length;
      let l3 = contributionList.length;
      let l4 = individualSalesList.length;
      let l5 = assigneeOutsidePartner.length;
      let l6 = assigneeOutsidePartnerRole.length;

      let flag = false;
      if (l1 === l2 && l2 === l3 && l3 === l4) {
        flag = true;
      }
      // データ保存用の配列
      let items: any = [];
      if (flag === true) {
        for (let i = 0; i < assigneeUser.length; i++) {
          let lenName = assigneeUser.length;
          let lenId = itemIds.length;
          let newArr1 = Array(lenName - lenId).fill(0);
          let concatArray1 = itemIds;
          let concatArray2 = concatArray1.concat(newArr1);
          setItemIds(concatArray2);

          items[i] = {
            id: concatArray2[i],
            assignee_user: assigneeUser[i],
            assignee_role: assigneeRole[i],
            contribution: contributionList[i],
            individual_sales: individualSalesList[i]
          };

          if (deleteItemList) {
            items.push(...deleteItemList);
          }
        }

        let arr: any = [];
        for (let n = 0; n < items.length; n++) {
          if (
            items[n].assignee_user ||
            items[n].assignee_role ||
            items[n].contribution ||
            items[n].individual_sales
          ) {
            arr.push(items[n]);
          }
        }

        // 社外パートナー
        let flag2 = false;
        if (l5 === l6) {
          flag2 = true;
        }
        let items2: any = [];
        if (flag2 === true) {
          for (let i = 0; i < assigneeOutsidePartner.length; i++) {
            let lenName2 = assigneeOutsidePartner.length;
            let lenId2 = itemIds2.length;
            let newArr2 = Array(lenName2 - lenId2).fill(0);
            let concatArray3 = itemIds2;
            let concatArray4 = concatArray3.concat(newArr2);
            setItemIds2(concatArray4);

            items2[i] = {
              id: concatArray4[i],
              assignee_user: assigneeOutsidePartner[i],
              assignee_role: assigneeOutsidePartnerRole[i],
              contribution: 0,
              individual_sales: 0
            };

            if (deleteItemList2) {
              items2.push(...deleteItemList2);
            }
          }

          let arr2: any = [];
          for (let n = 0; n < assigneeOutsidePartner.length; n++) {
            if (items2[n].assignee_user || items2[n].assignee_role) {
              arr2.push(items2[n]);
            }
          }
          updateFunction(arr, arr2);
        } else {
          setErrorMessage('社外パートナー情報を設定してください。');
          setOpen(true);
        }
      } else {
        setErrorMessage('担当者を設定してください。');
        setOpen(true);
      }
    }
  };

  const updateFunction = (newAssigneeArr: any, newOutsidePartnerArr: any) => {
    setIsSaved(true);
    updateConstruction(
      history.location.state.constructId,
      code.trim(),
      constructType,
      renewStatus,
      buildingScale,
      name.trim(),
      sitePrefecture,
      siteAddress1.trim(),
      siteAddress2.trim(),
      siteAddress3.trim(),
      remarks,
      contractorPrefecture,
      contractorAddress1.trim(),
      contractorAddress2.trim(),
      contractorAddress3.trim(),
      contractorName.trim(),
      contractorTel.trim(),
      progress,
      plannedCost,
      plannedDays,
      plannedGrossProfit,
      selectedContractDate !== null ? contractDate : '',
      selectedStartDate !== null ? startDate : '',
      selectedEndDate !== null ? endDate : '',
      selectedBillingDate !== null ? billingDate : '',
      selectedPaymentDate !== null ? paymentDate : '',
      selectedFailureDate !== null ? failureDate : '',
      selectedInspectionDate !== null ? inspectionDate : '',
      contractTaxRate,
      selectedExpectedContractDate !== null ? expectedContractDate : '',
      selectedExpectedStartDate !== null ? expectedStartDate : '',
      selectedExpectedEndDate !== null ? expectedEndDate : '',
      selectedExpectedPaymentDate !== null ? expectedPaymentDate : '',
      smallExpenses,
      newAssigneeArr,
      newOutsidePartnerArr,
      companyName.trim(),
      String(companyCode.trim()),
      String(companyPostalCode1.trim()) + String(companyPostalCode2.trim()),
      companyAddress.trim(),
      String(companyPhoneNumber.trim()),
      String(companyFaxNumber.trim()),
      latitude,
      longitude,
      isMarkerChecked,
      possibleTime.trim(),
      parkSpace.trim(),
      smokingRule.trim(),
      importantOthers.trim(),
      janitorName.trim(),
      janitorPhoneNumber.trim(),
      janitorFaxNumber.trim(),
      janitorWorkHours.trim(),
      janitorOthers.trim(),
      smallExpenseItems
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setErrorMessage(data.message);
            setOpenSuccess(true);
          }
        }
      }
    });
  };

  const updateSelectedMerchandiseStatus = (
    id: number,
    status: number
  ): Promise<string> => {
    return updateMerchandiseStatus(id, status).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
        return 'Not logged in';
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
          return 'Error';
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
            return 'Error';
          } else {
            return checkResData(data, enqueueSnackbar).then(() => {
              getListOfConstructEstimates();
              getTheDetailsOfConstrctions();
              getListOfConstructMerchandise();
              return 'Success'; // ここで成功のステータスを返す
            });
          }
        }
      }
    });
  };

  const changeEstimateStatus = (id: number, status: number) => {
    updateEstimateStatus(id, status).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            getListOfConstructEstimates();
            getTheDetailsOfConstrctions();
          }
        }
      }
    });
  };

  const changeInvoiceStatus = (id: number, status: number) => {
    updateInvoiceStatus(id, status).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            getListOfConstructInvoices();
            getTheDetailsOfConstrctions();
          }
        }
      }
    });
  };

  const updateReceiptIssueStatus = (id: number, receiptIssueFlg: number) => {
    updateInvoiceReceiptIssueStatus(id, receiptIssueFlg).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            getListOfConstructInvoices();
          }
        }
      }
    });
  };

  const updateOutsourceStatus = (id: number, status: number) => {
    partialUpdateOutsourceStatus(id, status).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            checkResData(data, enqueueSnackbar).then(() => {
              getListOfConstructOutSources();
              getTheDetailsOfConstrctions();
            });
          }
        }
      }
    });
  };

  /**
   * 請求書一覧の入金日更新
   */
  const handlePaymentConfirmDate = (
    id: number,
    paymentConfirmDate: Date | null
  ) => {
    let finalDate: any = '';
    if (paymentConfirmDate) {
      finalDate = formatDatetime(paymentConfirmDate, 'YYYY-MM-DD');
    }
    updatePaymentConfirmDate(id, finalDate).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            getListOfConstructInvoices();
            getTheDetailsOfConstrctions();
          }
        }
      }
    });
  };

  const deleteFunction = (j: number) => {
    if (rowCount.length === 1) {
      setErrorMessage('担当者情報は、1行以上必要です。');
      setOpen(true);
    } else {
      let newAssigneeRole: any = [...assigneeRole];
      let newContributionList: any = [...contributionList];
      let newAssigneeUser: any = [...assigneeUser];
      let newRowCount: any = [...rowCount];
      let newIndividualSalesList: any = [...individualSalesList];
      const deleteItem = {
        id: itemIds[j],
        assignee_user: assigneeUser[j],
        assignee_role: assigneeRole[j],
        contribution: contributionList[j],
        individual_sales: individualSalesList[j],
        delete: true
      };
      setDeleteItemList([...deleteItemList, deleteItem]);
      newAssigneeUser.splice(j, 1);
      newAssigneeRole.splice(j, 1);
      newContributionList.splice(j, 1);
      newIndividualSalesList.splice(j, 1);
      newRowCount.splice(j, 1);
      if (newAssigneeUser.length !== newRowCount.length) {
        newAssigneeUser.push(0);
      }
      if (newAssigneeRole.length !== newRowCount.length) {
        newAssigneeRole.push(0);
      }
      if (newContributionList.length !== newRowCount.length) {
        newContributionList.push(0);
      }
      if (newIndividualSalesList.length !== newRowCount.length) {
        newIndividualSalesList.push(0);
      }
      let newItemIds: any = [...itemIds];
      newItemIds.splice(j, 1);
      setItemIds(newItemIds);
      setRowCount(newRowCount);
      setAssigneeUser(newAssigneeUser);
      setContributionList(newContributionList);
      setIndividualSalesList(newIndividualSalesList);
      setAssigneeRole(newAssigneeRole);
    }
  };

  const getStatusFromId = (id: number) => {
    switch (id) {
      case 1:
        return <span>未着</span>;
      case 2:
        return <span>差戻し</span>;
      case 3:
        return <span>対応済み</span>;
      case 4:
        return <span>支払</span>;
      default:
        return <span></span>;
    }
  };

  const downloadFormat = (name: string, name_jp: string) => {
    const downloadLink = document.createElement('a');
    downloadLink.href = CONTRACT_FORMAT_DIR_PATH + name;
    downloadLink.download = name_jp;
    downloadLink.click();
  };

  // 各書類詳細から「戻る」を使用した場合の書類種選択
  const SelectTable = () => {
    if (history.location.state.params || history.location.state.tabs) {
      if (history.location.state.tabs === 'invoices') {
        setSelectedTable('invoices');
      } else {
        if (history.location.state.tabs === 'product-purchase-order') {
          setSelectedTable('product-purchase-order');
        } else {
          if (history.location.state.tabs === 'outsourced-purchase-order') {
            setSelectedTable('outsourced-purchase-order');
          } else {
            if (history.location.state.tabs === 'site-contacts') {
              setSelectedTable('site-contacts');
            }
          }
        }
      }
    } else {
      setSelectedTable('estimates');
    }
  };

  useEffect(() => {
    SelectTable();
  }, [history.location.state]);

  return (
    <>
      <AppBarComponent patternName='constructions_edit' />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent isFormGroup={true} />
        </>
      ) : (
        <>
          <div
            style={{
              overflow: 'hidden',
              backgroundColor: '#F5F5F5',
              minHeight: window.innerHeight
            }}
          >
            <div style={{ margin: 15 }}>
              <Snackbar
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
              >
                <Alert onClose={handleClose} severity='error'>
                  {errorMessage}
                </Alert>
              </Snackbar>

              <Snackbar
                open={openSuccess}
                autoHideDuration={4000}
                onClose={handleCloseSuccess}
              >
                <Alert onClose={handleCloseSuccess} severity='success'>
                  {errorMessage}
                </Alert>
              </Snackbar>
              <div className='table-top-container-customer'>
                <div style={{ fontWeight: 'bold' }}>
                  <Button
                    style={{
                      minWidth: 90,
                      marginRight: 15,
                      color: '#758283',
                      backgroundColor: '#F5F5F5',
                      marginBottom: !matches2 ? 10 : 0
                    }}
                    variant='contained'
                    color='secondary'
                    onClick={() => {
                      if ('previouspath' in history.location.state) {
                        history.go(-2);
                      } else history.goBack();
                    }}
                    startIcon={<ArrowBackIcon />}
                  >
                    戻る
                  </Button>
                </div>
              </div>
            </div>

            <div style={{ backgroundColor: '#FFFFFF' }}>
              <div className={classes.topContainer}>
                <div
                  style={{
                    backgroundColor: '#FFFFFF',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    marginLeft: 15,
                    marginTop: 24
                  }}
                >
                  <div style={{ fontSize: 18 }}>{topConstructionName}</div>
                  <div style={{ fontSize: 14, fontWeight: 'lighter' }}>
                    {topClientName}
                  </div>
                </div>
                <div>
                  {userMenu != 'BM' && (
                    <>
                      <ListButton
                        variant='contained'
                        style={{ marginRight: 12, marginTop: 24 }}
                        onClick={() => {
                          history.push(`/files`, {
                            state: {
                              id: history.location.state.constructId,
                              name: name
                            }
                          });
                        }}
                      >
                        資料一覧
                      </ListButton>
                      <ListButton
                        variant='contained'
                        style={{ marginRight: 12, marginTop: 24 }}
                        onClick={() => {
                          history.push(`/pictures`, {
                            state: {
                              id: history.location.state.constructId,
                              name: name
                            }
                          });
                        }}
                      >
                        写真一覧
                      </ListButton>
                    </>
                  )}
                  {/* NOTE: メニュー出し分けリリースまでの暫定対応 */}
                  {userSiteManagePlan != 99 && (
                    <ListButton
                      variant='contained'
                      style={{ marginRight: 15, marginTop: 24 }}
                      onClick={() => {
                        history.push(`/processes`, {
                          constructId: history.location.state.constructId,
                          name: topConstructionName
                        });
                      }}
                    >
                      工程表
                    </ListButton>
                  )}
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: matches2 ? 'row' : 'column'
                }}
                className={classes.topList}
              >
                <div
                  // 空アイテム
                  className='empty-list'
                  style={{ width: 15 }}
                ></div>
                <div
                  onClick={() => {
                    if (isSaved == true) {
                      history.push(
                        `/constructions/${history.location.state.constructId}/edit`,
                        {
                          constructId: history.location.state.constructId
                        }
                      );
                    } else {
                      setErrorMessage('保存してください。');
                      setOpen(true);
                    }
                  }}
                  className='border2'
                >
                  <div className={classes.topColumn}>工事情報</div>
                </div>
                <div
                  onClick={() => setSelectTab(2)}
                  className='border2'
                  style={{
                    backgroundColor: selectTab == 2 ? '#F5F5F5' : '#ffffff',
                    borderTopColor: selectTab == 2 ? '#0099CB' : '#cccccc',
                    borderBottom: selectTab == 2 ? 'none' : 'solid 1px #cccccc',
                    width: 200
                  }}
                >
                  <div
                    className={classes.topColumn}
                    style={{ color: selectTab == 2 ? '#0099CB' : '#000000' }}
                  >
                    書類情報
                  </div>
                </div>
                <div
                  onClick={() => {
                    if (isSaved == true) {
                      history.push(
                        `/constructions_location/${history.location.state.constructId}/edit`,
                        {
                          constructId: history.location.state.constructId
                        }
                      );
                    } else {
                      setErrorMessage('保存してください。');
                      setOpen(true);
                    }
                  }}
                  className='border2'
                >
                  <div className={classes.topColumn}>現場情報</div>
                </div>
                {defaultValues && defaultValues.length > 0 && (
                  <div
                    onClick={() => setSelectTab(4)}
                    className='border2'
                    style={{
                      backgroundColor: selectTab == 4 ? '#F5F5F5' : '#ffffff',
                      borderTopColor: selectTab == 4 ? '#0099CB' : '#cccccc',
                      borderBottom:
                        selectTab == 4 ? 'none' : 'solid 1px #cccccc',
                      width: 200
                    }}
                  >
                    <div
                      className={classes.topColumn}
                      style={{ color: selectTab == 4 ? '#0099CB' : '#000000' }}
                    >
                      追加情報
                    </div>
                  </div>
                )}
                <div
                  // 空アイテム
                  className='empty-list'
                  style={{ flexGrow: 1 }}
                ></div>
              </div>
            </div>

            {/** 書類情報の場合 */}
            {selectTab == 2 && (
              <>
                <div style={{ margin: 15 }}>
                  {!(userMenu === 'Storage' || userPlanId === 'SiteManage') && (
                    <>
                      <div
                        className={classes.topContainer}
                        style={{
                          marginLeft: 15,
                          marginTop: 30,
                          marginBottom: 20,
                          display: 'flex',
                          flexDirection: matches2 ? 'row' : 'column'
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row'
                          }}
                        >
                          <div
                            className={
                              selectedTable === 'estimates'
                                ? 'border-edit-construct'
                                : 'border-edit-construct1'
                            }
                            onClick={() => {
                              setSelectedTable('estimates');
                            }}
                          >
                            <div className={classes.topBoxText}>見積書</div>
                          </div>
                          <div
                            onClick={() => {
                              setSelectedTable('invoices');
                            }}
                            className={
                              selectedTable === 'invoices'
                                ? 'border-edit-construct'
                                : 'border-edit-construct1'
                            }
                          >
                            <div className={classes.topBoxText}>請求書</div>
                          </div>
                          <div
                            onClick={() => {
                              setSelectedTable('product-purchase-order');
                            }}
                            className={
                              selectedTable === 'product-purchase-order'
                                ? 'border-edit-construct'
                                : 'border-edit-construct1'
                            }
                          >
                            <div className={classes.topBoxText}>商品発注書</div>
                          </div>
                          <div
                            onClick={() => {
                              setSelectedTable('outsourced-purchase-order');
                            }}
                            className={
                              selectedTable === 'outsourced-purchase-order'
                                ? 'border-edit-construct'
                                : 'border-edit-construct1'
                            }
                          >
                            <div className={classes.topBoxText}>外注発注書</div>
                          </div>
                          <div
                            onClick={() => {
                              setSelectedTable('site-contacts');
                            }}
                            className={
                              selectedTable === 'site-contacts'
                                ? 'border-edit-construct'
                                : 'border-edit-construct1'
                            }
                          >
                            <div className={classes.topBoxText}>現場連絡表</div>
                          </div>
                          <div
                            onClick={() => {
                              setSelectedTable('contract-format');
                            }}
                            className={
                              selectedTable === 'contract-format'
                                ? 'border-edit-construct'
                                : 'border-edit-construct1'
                            }
                          >
                            <div className={classes.topBoxText}>
                              契約書フォーマット
                            </div>
                          </div>
                        </div>

                        <div>
                          {selectedTable === 'estimates' && (
                            <Button
                              style={{
                                backgroundColor: buttonColor,
                                marginRight: 10,
                                marginBottom: 10
                              }}
                              variant='contained'
                              color='secondary'
                              startIcon={<NoteAddIcon />}
                              onClick={() => {
                                history.push(`/estimates/create`, {
                                  constructId:
                                    history.location.state.constructId,
                                  previouspath: history.location.pathname
                                });
                              }}
                            >
                              新規見積書作成
                            </Button>
                          )}

                          {selectedTable === 'invoices' && (
                            <Button
                              style={{
                                backgroundColor: buttonColor,
                                marginRight: 10,
                                marginBottom: 10
                              }}
                              variant='contained'
                              color='secondary'
                              startIcon={<NoteAddIcon />}
                              onClick={() => {
                                history.push('/invoices/create', {
                                  constructId:
                                    history.location.state.constructId,
                                  previouspath: history.location.pathname
                                });
                              }}
                            >
                              新規請求書作成
                            </Button>
                          )}

                          {selectedTable === 'product-purchase-order' && (
                            <Button
                              style={{
                                backgroundColor: buttonColor,
                                marginRight: 10,
                                marginBottom: 10
                              }}
                              variant='contained'
                              color='secondary'
                              startIcon={<NoteAddIcon />}
                              onClick={() => {
                                history.push('/merchandise-orders/create', {
                                  constructId:
                                    history.location.state.constructId,
                                  previouspath: history.location.pathname
                                });
                              }}
                            >
                              新規商品発注書作成
                            </Button>
                          )}

                          {selectedTable === 'outsourced-purchase-order' && (
                            <Button
                              style={{
                                backgroundColor: buttonColor,
                                marginRight: 10,
                                marginBottom: 10
                              }}
                              variant='contained'
                              color='secondary'
                              startIcon={<NoteAddIcon />}
                              onClick={() => {
                                history.push('/outsource-orders/create', {
                                  constructId:
                                    history.location.state.constructId,
                                  previouspath: history.location.pathname
                                });
                              }}
                            >
                              新規外注発注書作成
                            </Button>
                          )}

                          {selectedTable === 'site-contacts' && (
                            <Button
                              style={{
                                backgroundColor: buttonColor,
                                marginRight: 10,
                                marginBottom: 10
                              }}
                              variant='contained'
                              color='secondary'
                              startIcon={<NoteAddIcon />}
                              onClick={() => {
                                history.push('/site-contacts/create', {
                                  constructId:
                                    history.location.state.constructId,
                                  previouspath: history.location.pathname,
                                  client: topClientName
                                });
                              }}
                            >
                              新規現場連絡表作成
                            </Button>
                          )}
                        </div>
                      </div>

                      {selectedTable === 'estimates' && (
                        <TableContainer component={Paper}>
                          <Table
                            className={classes.main}
                            aria-label='customized table'
                          >
                            <TableHead>
                              <TableRow>
                                <StyledTableCell
                                  style={{ minWidth: 80 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  見積書番号
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 80 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  ステータス
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 90 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: '#FFFFFF',
                                        fontWeight: 'bold'
                                      }}
                                    >
                                      見積提出日
                                    </div>
                                    <SortButton
                                      buttonName='submission_date'
                                      getListData={getListOfConstructEstimates}
                                      sortButtonName={sortEstimateButtonName}
                                      setSortButtonName={
                                        setEstimateSortButtonName
                                      }
                                      changeSortParams={
                                        changeEstimateSortParams
                                      }
                                    />
                                  </div>
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 250 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  見積件名
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 120 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  請求先顧客名
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 80 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  営業担当者
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 90 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  積算担当
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 90 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  見積合計金額
                                </StyledTableCell>
                                {/* <StyledTableCell
                              className={classes.table}
                              align="center"
                            ></StyledTableCell> */}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {constructEstimatesData.map(
                                (row: any, index: number) => (
                                  <StyledTableRow
                                    className='click_table_row'
                                    title='編集'
                                  >
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/estimates/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.code}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                    >
                                      <select
                                        value={row.status}
                                        onChange={text => {
                                          setIsSaved(false);
                                          changeEstimateStatus(
                                            parseInt(row.id),
                                            parseInt(text.target.value)
                                          );
                                        }}
                                        className={classes.inputBottom}
                                        style={{ height: 35 }}
                                      >
                                        <option value={0} disabled>
                                          選択してください
                                        </option>
                                        <option value={1}>作成中</option>
                                        <option value={2}>変更</option>
                                        <option value={3}>売上予定</option>
                                        <option value={4}>受注</option>
                                        <option value={5}>失注</option>
                                      </select>
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/estimates/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.submission_date}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/estimates/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.construct_sub}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/estimates/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.billing_customer_name}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/estimates/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.sales_user_name}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/estimates/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.accountant_user_name}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='right'
                                      onClick={() => {
                                        history.push(
                                          `/estimates/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {parsePrice(row.estimated_total)}
                                    </StyledTableCell>

                                    {/* <StyledTableCell
                                className={classes.table1}
                                align="center"
                              >
                                <Button
                                  style={{ backgroundColor: buttonColor }}
                                  variant="contained"
                                  color="primary"
                                  onClick={() => {
                                    history.push(`/estimates/${row.id}/edit`, {
                                      state: row.id,
                                      constructId: row.construct_id,
                                    });
                                  }}
                                >
                                  編集
                                </Button>
                              </StyledTableCell> */}
                                  </StyledTableRow>
                                )
                              )}
                            </TableBody>
                          </Table>
                          {!loading && constructEstimatesData.length === 0 && (
                            <div className={classes.container}>
                              データがありません
                            </div>
                          )}
                        </TableContainer>
                      )}

                      {selectedTable === 'invoices' && (
                        <TableContainer component={Paper}>
                          <Table
                            className={classes.main}
                            aria-label='customized table'
                          >
                            <TableHead>
                              <TableRow>
                                <StyledTableCell
                                  style={{ minWidth: 80 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  ステータス
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 80 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  工事件名
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 90 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  請求先顧客名
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 100 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  請求金額(税抜)
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 100 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  請求金額(税込)
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 90 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  請求区分
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 90 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: '#FFFFFF',
                                        fontWeight: 'bold'
                                      }}
                                    >
                                      請求書発行日
                                    </div>
                                    <SortButton
                                      buttonName='published_date'
                                      getListData={getListOfConstructEstimates}
                                      sortButtonName={sortInvoiceButtonName}
                                      setSortButtonName={
                                        setSortInvoiceButtonName
                                      }
                                      changeSortParams={changeInvoiceSortParams}
                                    />
                                  </div>
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 90 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: '#FFFFFF',
                                        fontWeight: 'bold'
                                      }}
                                    >
                                      支払期日
                                    </div>
                                    <SortButton
                                      buttonName='payment_date'
                                      getListData={getListOfConstructEstimates}
                                      sortButtonName={sortInvoiceButtonName}
                                      setSortButtonName={
                                        setSortInvoiceButtonName
                                      }
                                      changeSortParams={changeInvoiceSortParams}
                                    />
                                  </div>
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 90 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: '#FFFFFF',
                                        fontWeight: 'bold'
                                      }}
                                    >
                                      入金確認確認日
                                    </div>
                                    <SortButton
                                      buttonName='confirm_date'
                                      getListData={getListOfConstructEstimates}
                                      sortButtonName={sortInvoiceButtonName}
                                      setSortButtonName={
                                        setSortInvoiceButtonName
                                      }
                                      changeSortParams={changeInvoiceSortParams}
                                    />
                                  </div>
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 80 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  送付区分
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 140 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  領収書
                                </StyledTableCell>
                                {/* <StyledTableCell
                              className={classes.table}
                              align="center"
                            ></StyledTableCell> */}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {constructInvoicesData.map(
                                (row: any, index: number) => (
                                  <StyledTableRow
                                    className='click_table_row'
                                    title='編集'
                                  >
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                    >
                                      <select
                                        value={row.status}
                                        onChange={text => {
                                          setIsSaved(false);
                                          changeInvoiceStatus(
                                            parseInt(row.id),
                                            parseInt(text.target.value)
                                          );
                                        }}
                                        className={classes.inputBottom}
                                        style={{ height: 35 }}
                                      >
                                        <option value={0} disabled>
                                          選択してください
                                        </option>
                                        <option value={1}>送付</option>
                                        <option value={2}>未送付</option>
                                      </select>
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/invoices/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.construct_sub}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/invoices/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.billing_customer_name}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='right'
                                      onClick={() => {
                                        history.push(
                                          `/invoices/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {parsePrice(row.billing_amount)}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='right'
                                      onClick={() => {
                                        history.push(
                                          `/invoices/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {parsePrice(
                                        row.billing_amount_including_tax
                                      )}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/invoices/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.billing_type}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/invoices/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.issue_date}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/invoices/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.due_date}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      style={{ minWidth: 220 }}
                                      align='left'
                                    >
                                      <div
                                        style={{
                                          marginLeft: 10,
                                          marginRight: 15,
                                          backgroundColor: '#FFFFFF',
                                          height: 28,
                                          paddingBottom: 5,
                                          paddingLeft: 5
                                        }}
                                        className={'select-div-div'}
                                      >
                                        <DatePickerInput
                                          date={
                                            row.payment_confirm_date !== ''
                                              ? row.payment_confirm_date
                                              : null
                                          }
                                          onChange={val => {
                                            setIsSaved(false);
                                            handlePaymentConfirmDate(
                                              row.id,
                                              val
                                            );
                                          }}
                                          id={`payment_confirm_date${index}`}
                                          emptyLabel='入金日'
                                          disabled={row.receipt_issue_flg == 1}
                                        />
                                      </div>
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/invoices/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.delivery_method}
                                    </StyledTableCell>

                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      style={{ minWidth: 200 }}
                                    >
                                      <Button
                                        style={{
                                          backgroundColor: buttonColor,
                                          minWidth: 150
                                        }}
                                        variant='contained'
                                        color='primary'
                                        onClick={() => {
                                          if (row.payment_confirm_date === '') {
                                            setErrorMessage(
                                              '入金日を入力してください。'
                                            );
                                            setOpen(true);
                                          } else {
                                            updateReceiptIssueStatus(
                                              row.id,
                                              RECEIPT_ISSUE_STATUS.ISSUED
                                            );
                                            history.push(
                                              `/receipts/${row.id}/preview`,
                                              {
                                                rowId: row.id,
                                                constructId: row.construct_id
                                              }
                                            );
                                          }
                                        }}
                                      >
                                        {row.receipt_issue_flg === 1
                                          ? '領収書発行(再)'
                                          : '領収書発行'}
                                      </Button>
                                    </StyledTableCell>

                                    {/* <StyledTableCell
                                className={classes.table1}
                                align="center"
                              >
                                <Button
                                  style={{ backgroundColor: buttonColor }}
                                  variant="contained"
                                  color="primary"
                                  onClick={() => {
                                    history.push(`/invoices/${row.id}/edit`, {
                                      state: row.id,
                                      constructId: history.location.state.constructId,
                                    });
                                  }}
                                >
                                  編集
                                </Button>
                              </StyledTableCell> */}
                                  </StyledTableRow>
                                )
                              )}
                            </TableBody>
                          </Table>
                          {!loading && constructInvoicesData.length === 0 && (
                            <div className={classes.container}>
                              データがありません
                            </div>
                          )}
                        </TableContainer>
                      )}

                      {selectedTable === 'product-purchase-order' && (
                        <TableContainer component={Paper}>
                          <Table
                            className={classes.main}
                            aria-label='customized table'
                          >
                            <TableHead>
                              <TableRow>
                                <StyledTableCell
                                  style={{ minWidth: 80 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  ステータス
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 160 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  工事件名
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 90 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  現場担当
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 140 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  工事種別
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 200 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  業種
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 140 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  支払予定日
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 140 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: '#FFFFFF',
                                        fontWeight: 'bold'
                                      }}
                                    >
                                      発注日
                                    </div>
                                    <SortButton
                                      buttonName='order_date'
                                      getListData={
                                        getListOfConstructMerchandise
                                      }
                                      sortButtonName={sortMerchandiseButtonName}
                                      setSortButtonName={
                                        setSortMerchandiseButtonName
                                      }
                                      changeSortParams={
                                        changeMerchandiseSortParams
                                      }
                                    />
                                  </div>
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 140 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  発注先
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 90 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  品名<div>仕様</div>
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 100 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  金額（税抜）
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 100 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  金額（税込）
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 80 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  納品先
                                </StyledTableCell>
                                {/* <StyledTableCell
                              className={classes.table}
                              align="center"
                            ></StyledTableCell> */}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {constructMerchandiseData.map(
                                (row: any, index: number) => (
                                  <StyledTableRow
                                    className='click_table_row'
                                    title='編集'
                                  >
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                    >
                                      {userPermission === 1 ||
                                      userPermission === null ? (
                                        <select
                                          value={itemStatus[index]}
                                          onChange={text => {
                                            setIsSaved(false);
                                            let newArr = [...itemStatus];
                                            newArr[index] = parseInt(
                                              text.target.value
                                            );
                                            updateSelectedMerchandiseStatus(
                                              parseInt(row.id),
                                              parseInt(text.target.value)
                                            ).then(result => {
                                              if (result === 'Success') {
                                                setItemStatus(newArr);
                                              }
                                            });
                                          }}
                                          className={classes.inputBottom}
                                          style={{ height: 35 }}
                                        >
                                          <option value={1}>未着</option>
                                          <option value={2}>差戻し</option>
                                          <option value={3}>対応済み</option>
                                          <option value={4}>支払</option>
                                        </select>
                                      ) : (
                                        getStatusFromId(itemStatus[index])
                                      )}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/merchandise-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.construct_sub}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/merchandise-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.site_user_name}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/merchandise-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.construct_type}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/merchandise-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.industry1}
                                      <div>{row.industry2}</div>
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/merchandise-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.payment_date}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/merchandise-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.order_date}
                                    </StyledTableCell>

                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/merchandise-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.partner}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/merchandise-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.product_name}
                                      <div>{row.product_spec}</div>
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='right'
                                      onClick={() => {
                                        history.push(
                                          `/merchandise-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {parsePrice(row.total_amount)}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='right'
                                      onClick={() => {
                                        history.push(
                                          `/merchandise-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {parsePrice(
                                        parseInt(row.total_amount) +
                                          calcTax(
                                            parseInt(row.total_amount),
                                            contractTaxRate / 100,
                                            taxRule
                                          )
                                      )}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/merchandise-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.delivery_site}
                                    </StyledTableCell>

                                    {/* <StyledTableCell
                                  className={classes.table1}
                                  align="center"
                                >
                                  <Button
                                    style={{ backgroundColor: buttonColor }}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                      history.push(
                                        `/merchandise-orders/${row.id}/edit`,
                                        { state: row.id }
                                      );
                                    }}
                                  >
                                    編集
                                  </Button>
                                </StyledTableCell> */}
                                  </StyledTableRow>
                                )
                              )}
                            </TableBody>
                          </Table>
                          {!loading &&
                            constructMerchandiseData.length === 0 && (
                              <div className={classes.container}>
                                データがありません
                              </div>
                            )}
                        </TableContainer>
                      )}
                      {selectedTable === 'outsourced-purchase-order' && (
                        <TableContainer component={Paper}>
                          <Table
                            className={classes.main}
                            aria-label='customized table'
                          >
                            <TableHead>
                              <TableRow>
                                <StyledTableCell
                                  style={{ minWidth: 80 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  ステータス
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 160 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  工事件名
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 115 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  営業担当
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 140 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  工事種別
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 140 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: '#FFFFFF',
                                        fontWeight: 'bold'
                                      }}
                                    >
                                      支払日
                                    </div>
                                    <SortButton
                                      buttonName='payment_date'
                                      getListData={getListOfConstructOutSources}
                                      sortButtonName={sortOutsourceButtonName}
                                      setSortButtonName={
                                        setSortOutsourceButtonName
                                      }
                                      changeSortParams={
                                        changeOutsourceSortParams
                                      }
                                    />
                                  </div>
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 140 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: '#FFFFFF',
                                        fontWeight: 'bold'
                                      }}
                                    >
                                      発注日
                                    </div>
                                    <SortButton
                                      buttonName='order_date'
                                      getListData={getListOfConstructOutSources}
                                      sortButtonName={sortOutsourceButtonName}
                                      setSortButtonName={
                                        setSortOutsourceButtonName
                                      }
                                      changeSortParams={
                                        changeOutsourceSortParams
                                      }
                                    />
                                  </div>
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 140 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: '#FFFFFF',
                                        fontWeight: 'bold'
                                      }}
                                    >
                                      開始日
                                    </div>
                                    <SortButton
                                      buttonName='job_start_date'
                                      getListData={getListOfConstructOutSources}
                                      sortButtonName={sortOutsourceButtonName}
                                      setSortButtonName={
                                        setSortOutsourceButtonName
                                      }
                                      changeSortParams={
                                        changeOutsourceSortParams
                                      }
                                    />
                                  </div>
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 140 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: '#FFFFFF',
                                        fontWeight: 'bold'
                                      }}
                                    >
                                      終了日
                                    </div>
                                    <SortButton
                                      buttonName='job_end_date'
                                      getListData={getListOfConstructOutSources}
                                      sortButtonName={sortOutsourceButtonName}
                                      setSortButtonName={
                                        setSortOutsourceButtonName
                                      }
                                      changeSortParams={
                                        changeOutsourceSortParams
                                      }
                                    />
                                  </div>
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 140 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  発注先
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 140 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  予定原価合計（税抜）
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 140 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  予定原価合計（税込）
                                </StyledTableCell>
                                {/* <StyledTableCell
                              className={classes.table}
                              align="center"
                            ></StyledTableCell> */}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {constructOutSourcesData.map(
                                (row: any, index: number) => (
                                  <StyledTableRow
                                    className='click_table_row'
                                    title='編集'
                                  >
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                    >
                                      {userPermission === 1 ||
                                      userPermission === null ? (
                                        <select
                                          value={row.status}
                                          onChange={text => {
                                            setIsSaved(false);
                                            updateOutsourceStatus(
                                              parseInt(row.id),
                                              parseInt(text.target.value)
                                            );
                                          }}
                                          className={classes.inputBottom}
                                          style={{ height: 35 }}
                                        >
                                          <option value={1}>未着</option>
                                          <option value={2}>差戻し</option>
                                          <option value={3}>対応済み</option>
                                          <option value={4}>支払</option>
                                        </select>
                                      ) : (
                                        getStatusFromId(row.status)
                                      )}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/outsource-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.construct_sub}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/outsource-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.site_user_name}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/outsource-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.construct_type}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/outsource-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.payment_date}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/outsource-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.order_date}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/outsource-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.job_start_date}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/outsource-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.job_end_date}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/outsource-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.partner}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='right'
                                      onClick={() => {
                                        history.push(
                                          `/outsource-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {parsePrice(row.total_amount)}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='right'
                                      onClick={() => {
                                        history.push(
                                          `/outsource-orders/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {parsePrice(
                                        parseInt(row.total_amount) +
                                          calcTax(
                                            parseInt(row.total_amount),
                                            contractTaxRate / 100,
                                            taxRule
                                          )
                                      )}
                                    </StyledTableCell>

                                    {/* <StyledTableCell
                                  className={classes.table1}
                                  align="center"
                                >
                                  <Button
                                    style={{ backgroundColor: buttonColor }}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                      history.push(
                                        `/outsource-orders/${row.id}/edit`,
                                        { state: row.id }
                                      );
                                    }}
                                  >
                                    編集
                                  </Button>
                                </StyledTableCell> */}
                                  </StyledTableRow>
                                )
                              )}
                            </TableBody>
                          </Table>
                          {!loading && constructOutSourcesData.length === 0 && (
                            <div className={classes.container}>
                              データがありません
                            </div>
                          )}
                        </TableContainer>
                      )}

                      {/* 現場連絡表一覧 */}
                      {selectedTable === 'site-contacts' && (
                        <TableContainer component={Paper}>
                          <Table
                            className={classes.main}
                            aria-label='customized table'
                          >
                            <TableHead>
                              <TableRow>
                                <StyledTableCell
                                  style={{ minWidth: 80 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  現場連絡表番号
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 80 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  工事件名
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 140 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: '#FFFFFF',
                                        fontWeight: 'bold'
                                      }}
                                    >
                                      工事日
                                    </div>
                                    <SortButton
                                      buttonName='construct_date'
                                      getListData={
                                        getListOfConstructSiteContacts
                                      }
                                      sortButtonName={sortSiteContactButtonName}
                                      setSortButtonName={
                                        setSortSiteContactButtonName
                                      }
                                      changeSortParams={
                                        changeSiteContactSortParams
                                      }
                                    />
                                  </div>
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 115 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  職長
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 140 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  施工会社
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 140 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  集合時間
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 140 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  担当者
                                </StyledTableCell>
                                {/* <StyledTableCell
                          style={{ minWidth: 140 }}
                          className={classes.table}
                          align="center"
                        >
                          現場担当者TEL
                        </StyledTableCell> */}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {constructSiteContactsData.map(
                                (row: any, index: number) => (
                                  <StyledTableRow
                                    className='click_table_row'
                                    title='編集'
                                  >
                                    {/* 現場連絡表番号 */}
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/site-contacts/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.code}
                                    </StyledTableCell>
                                    {/* 工事件名 */}
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/site-contacts/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.construct_sub}
                                    </StyledTableCell>
                                    {/* 工事日 */}
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/site-contacts/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.construct_date}
                                    </StyledTableCell>
                                    {/* 職長 */}
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/site-contacts/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.foreman}
                                    </StyledTableCell>
                                    {/* 施工会社 */}
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/site-contacts/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.work_company}
                                    </StyledTableCell>
                                    {/* 集合時間 */}
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/site-contacts/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            rowId: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.meetup_time}
                                    </StyledTableCell>
                                    {/* 担当者 */}
                                    <StyledTableCell
                                      className={classes.table1}
                                      align='center'
                                      onClick={() => {
                                        history.push(
                                          `/site-contacts/${row.id}/edit`,
                                          {
                                            //選択した文書の番号、constructIdは工事番号
                                            state: row.id,
                                            constructId:
                                              history.location.state
                                                .constructId,
                                            previouspath: 'to_construction',
                                            //タブの情報を渡す
                                            tabs: selectedTable
                                          }
                                        );
                                      }}
                                    >
                                      {row.site_user_name}
                                    </StyledTableCell>
                                  </StyledTableRow>
                                )
                              )}
                            </TableBody>
                          </Table>
                          {!loading &&
                            constructSiteContactsData.length === 0 && (
                              <div className={classes.container}>
                                データがありません
                              </div>
                            )}
                        </TableContainer>
                      )}

                      {selectedTable === 'contract-format' && (
                        <div style={{ backgroundColor: '#F5F5F5' }}>
                          <div
                            style={{
                              overflow: 'hidden',
                              backgroundColor: '#F5F5F5',
                              minHeight: window.innerHeight - 150
                            }}
                          >
                            <TableContainer component={Paper}>
                              <Table
                                className={classes.main}
                                aria-label='customized table'
                              >
                                <TableHead>
                                  <TableRow>
                                    <StyledTableCell
                                      className={classes.table}
                                      align='center'
                                      style={{ minWidth: 40 }}
                                    ></StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table}
                                      align='center'
                                      style={{ minWidth: 80 }}
                                    >
                                      フォーマットファイル名
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className={classes.table}
                                      align='center'
                                      style={{ minWidth: 120 }}
                                    ></StyledTableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {formatFiles.map((file: any) => (
                                    <StyledTableRow>
                                      <StyledTableCell align='center'>
                                        <img
                                          src={
                                            CONTRACT_FORMAT_ICON_DIR_PATH +
                                            file.icon
                                          }
                                          style={{ height: 36 }}
                                        />
                                      </StyledTableCell>
                                      <StyledTableCell align='center'>
                                        {file.name_jp}
                                      </StyledTableCell>
                                      <StyledTableCell align='center'>
                                        <Button
                                          style={{
                                            backgroundColor: buttonColor
                                          }}
                                          variant='contained'
                                          color='primary'
                                          onClick={() => {
                                            downloadFormat(
                                              file.name,
                                              file.name_jp
                                            );
                                            log.info(
                                              `download: ${file.name_jp}`
                                            );
                                          }}
                                          startIcon={<GetAppIcon />}
                                        >
                                          ダウンロード
                                        </Button>
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div style={{ height: 80 }} />
                <div
                  className='save-btn-container'
                  style={{
                    backgroundColor: '#FFFFFF',
                    position: 'fixed',
                    bottom: 0,
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-around'
                  }}
                >
                  <div />
                  <div>
                    <Button
                      onClick={updateConstructionDetails}
                      style={{
                        paddingLeft: 50,
                        paddingRight: 50,
                        margin: 20,
                        backgroundColor: buttonColor
                      }}
                      variant='contained'
                      color='primary'
                    >
                      保存
                    </Button>
                  </div>
                  <div />
                </div>
              </>
            )}

            {/** 追加情報の場合 */}
            {selectTab === 4 && defaultValues && defaultValues.length > 0 && (
              <>
                <ExtInfoBoxes
                  defaultValues={defaultValues}
                  targetId={history.location.state.constructId}
                  ext_info_screen_type={EXT_INFO_SCREEN_TYPE.CONSTRUCT}
                  setOpen={setOpen}
                  setOpenSuccess={setOpenSuccess}
                  setErrorMessage={setErrorMessage}
                  getData={getData}
                />
                <div style={{ height: 80 }} />
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};
